import {
  Container,
  BackgroundImage,
  Title,
  createStyles,
  Stack,
} from '@mantine/core';
// Import AOS
import Aos from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';

const useStyle = createStyles((theme) => ({
  backgroundimage: {
    height: '100vh',
    display: 'flex!important',
  },
  container: {
    display: 'flex!important',
    alignItems: 'center',
    paddingLeft: 0,
  },
  title1: {
    '@media (min-width: 600px)': {
      display: 'none',
    },
    fontFamily: 'Poppins, sans-serif',
    color: '#F56600',
    fontSize: 48,
    fontWeight: 700,
  },
  title: {
    fontFamily: 'Poppins, sans-serif',
    fontSize: 96,
    fontWeight: 700,
    color: '#FEFEFD',
    '@media (max-width: 600px)': {
      fontSize: 20,
    },
    '@media (min-width: 600px)': {
      fontSize: 40,
    },
    '@media (min-width: 992px)': {
      fontSize: 80,
    },
    '@media (min-width: 1200px)': {
      fontSize: 96,
    },
  },
}));
const JumboTron3Compo = () => {
  const { classes } = useStyle();
  useEffect(() => {
    Aos.init({
      duration: 300,
      easing: 'ease-in-sine',
      offset: 200,
      delay: 100,
    });
  }, []);
  return (
    <div>
      <BackgroundImage
        src={require('../../assets/images/timSepakat.png')}
        className={classes.backgroundimage}
      >
        <Container data-aos="fade-up" className={classes.container}>
          <Stack>
            <Title className={classes.title1}>Sepakat</Title>
            <Title className={classes.title}>#MudahCariProperti</Title>
          </Stack>
        </Container>
      </BackgroundImage>
    </div>
  );
};
export default JumboTron3Compo;
